import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";

import CustomizedSnackbar from "../Snackbar/CustomizedSnackbar.jsx";

import firebase from "firebase/app";
import "firebase/auth";

const styles = theme => ({
	layout: {
		width: "auto",
		display: "block", // Fix IE11 issue.
		marginLeft: theme.spacing(3),
		marginRight: theme.spacing(3),
		[theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
			width: 400,
			marginLeft: "auto",
			marginRight: "auto"
		}
	},
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing.unit *
			3}px`
	},
	avatar: {
		margin: theme.spacing(),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: "100%", // Fix IE11 issue.
		marginTop: theme.spacing()
	},
	submit: {
		marginTop: theme.spacing(3)
	}
});

class SignIn extends React.Component {
	constructor() {
		super();
		this.state = { snackbarTrigger: false };
	}
	submit = event => {
		const email = document.getElementById("signInEmail").value;
		const password = document.getElementById("signInPassword").value;
		event.preventDefault();
		firebase
			.auth()
			.signInWithEmailAndPassword(email, password)
			.catch(error => {
				// firebase.auth().createUserWithEmailAndPassword(email, password);
				this.triggerSnackbar(error.message, "error");
				console.error(error);
			});
	};
	triggerSnackbar = (message, variant) => {
		this.setState({
			snackbarMessage: message,
			snackbarVariant: variant,
			snackbarTrigger: true,
			submmiting: false,
			submmitingComment: false
		});
	};
	onSnackbarClose = () => {
		this.setState({ snackbarTrigger: false });
	};
	render() {
		const { classes } = this.props;
		return (
			<React.Fragment>
				<CssBaseline />
				{this.state.snackbarTrigger && (
					<CustomizedSnackbar
						message={this.state.snackbarMessage}
						trigger={this.state.snackbarTrigger}
						variant={this.state.snackbarVariant}
						onClose={this.onSnackbarClose}
					/>
				)}
				<main className={classes.layout}>
					<Paper className={classes.paper}>
						<Avatar className={classes.avatar}>
							<LockIcon />
						</Avatar>
						Sign in
						<form className={classes.form} onSubmit={this.submit}>
							<FormControl margin="normal" required fullWidth>
								<InputLabel htmlFor="email">Email Address</InputLabel>
								<Input
									id="signInEmail"
									name="email"
									autoComplete="email"
									autoFocus
								/>
							</FormControl>
							<FormControl margin="normal" required fullWidth>
								<InputLabel htmlFor="password">Password</InputLabel>
								<Input
									name="password"
									type="password"
									id="signInPassword"
									autoComplete="current-password"
								/>
							</FormControl>
							{/*<FormControlLabel
								control={<Checkbox value="remember" color="primary" />}
								label="Remember me"
							/>*/}
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
							>
								Sign in
							</Button>
						</form>
					</Paper>
				</main>
			</React.Fragment>
		);
	}
}

SignIn.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SignIn);
